export const StorageKeys = {
  ISSUER_URI: 'aide_issuer_uri',
  OPENID_CONFIG: 'aide_openid_config',
  TOKEN_RESPONSE: 'aide_token_response',
  REDIRECT_URL: 'aide_redirect_url',
  LAST_ACTIVITY: 'aide_last_activity',
} as const;
